import EventEmitter from 'events'
import { each } from 'lodash';

import { app } from '../utils/store'

import { Navigation, Footer } from '../modules/Navigation'
import { BottomBar } from '../modules/BottomBar'

import Menu from '../modules/Menu'

export default class Page extends EventEmitter {
    constructor({
        element,
        elements,
        id, 
        scroll
    }){
        super()
        
        this.scroll = (scroll ? scroll : window)
        this.selector = element
        this.selectorChildren = { ...elements }
        
        this.id = id
    }

    create(){
        app.scroll = this.scroll
        app.current = this.id
        
        this.element = document.querySelector(this.selector)
        this.elements = {}

        this.scroll = {
            current: 0,
            target: 0,
            last: 0,
            limit: 0
        }

        each(this.selectorChildren, (entry, key) =>{
            if(entry instanceof window.HTMLElement || entry instanceof window.NodeList || Array.isArray(entry)){ // if is an element or an Array of the document
                this.elements[key] = entry
            } else {
                this.elements[key] = document.querySelectorAll(entry)

                if(this.elements[key].length === 0){
                    this.elements[key] = null
                } else if(this.elements[key].length === 1){
                    this.elements[key] = document.querySelector(entry)
                }
            }
        })

        app.html.scrollTop = 0
        app.root.scrollTop = 0

        this.createNavigation()
        this.addEventListeners()
    }

    // Create Navigation
    createNavigation = () => {
        this.statusbar = document.querySelector('[data-navigation-bottom-bar]')
        this.menu = document.querySelectorAll('[data-navigation-menu]')

        this.navigation = new Navigation()
        this.footer = new Footer()
        if (this.statusbar) { this.statusbar = new BottomBar() }

        if (this.menu) { each(this.menu, (entry, index) => new Menu({ element: entry })) }
    }

    /*
    ** Listeners
    */ 
    addEventListeners () { }

    removeEventListeners () { }

    /* Destroy */ 
    destroy = () => {
        this.removeEventListeners()
    }
}